module.exports = new __parcel__URL__("Ishi.9e2684bf.png").toString();